module.exports = __webpack_public_path__ + "stylesheets/edu_1550495e42c59ca9801395d4c3945e0e.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/edu.less
// module id = TBjL
// module chunks = 55